/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  const shopifySections = document.querySelectorAll('.shopify-section.index-section');

  shopifySections.forEach(section => {
    const columnContents = section.querySelectorAll('.column__content');
    columnContents.forEach(columnContent => {
      const link = columnContent.querySelector('a[href]');
      if (link) {
        const href = link.href;
        const gridItem = columnContent.closest('.grid-item');
        if (gridItem) {
          const newLink = document.createElement('a');
          newLink.href = href;
          while (gridItem.firstChild) {
            newLink.appendChild(gridItem.firstChild);
          }
          gridItem.appendChild(newLink);
        }
      }
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
